import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Grid,
  Divider,
  IconButton,
} from "@material-ui/core";
import { formatCurrency } from "../../helpers/currency";
import { Close } from "@material-ui/icons";

function numberToWords(num) {
  if (num === 0) return "zero";

  const belowTwenty = [
    "",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
  ];

  const tens = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  const units = [
    { value: 10000000, str: "crore" },
    { value: 100000, str: "lakh" },
    { value: 1000, str: "thousand" },
    { value: 100, str: "hundred" },
  ];

  function twoDigits(n) {
    if (n < 20) return belowTwenty[n];
    const ten = Math.floor(n / 10);
    const unit = n % 10;
    return tens[ten] + (unit ? " " + belowTwenty[unit] : "");
  }

  function convert(n) {
    if (n < 100) return twoDigits(n);

    let result = "";

    for (let { value, str } of units) {
      if (n >= value) {
        const quotient = Math.floor(n / value);
        const remainder = n % value;
        result += convert(quotient) + " " + str;
        if (remainder) result += " " + convert(remainder);
        return result;
      }
    }

    // For numbers between 100 and 999
    const hundredPart = Math.floor(n / 100);
    const remainder = n % 100;
    result += belowTwenty[hundredPart] + " hundred";
    if (remainder) result += " " + convert(remainder);
    return result;
  }

  return convert(num).trim();
}

function BalanceConfirmationDialog({
  open,
  onClose,
  amount,
  action,
  balanceType,
  remark,
  onConfirm,
  currency = "INR",
}) {
  const amountInWords = numberToWords(amount) + " Rupees Only";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle style={{ paddingTop: 8, paddingBottom: 8, paddingRight: 8 }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          style={{ margin: 0 }}
        >
          <Typography variant="h3">Confirm Balance Modification</Typography>
          <IconButton onClick={onClose} style={{ margin: 0 }}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Box>
          <Grid container spacing={3}>
            <Grid item xs={12} style={{ marginTop: 10 }}>
              <Typography variant="subtitle1" gutterBottom>
                Please review the following details:
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" color="textSecondary">
                Amount
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">
                {formatCurrency(currency, amount)}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" color="textSecondary">
                Amount (in words)
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography
                variant="body1"
                style={{ textTransform: "capitalize" }}
              >
                {amountInWords}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" color="textSecondary">
                Action
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">{action}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" color="textSecondary">
                Balance Type
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">{balanceType}</Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography variant="body1" color="textSecondary">
                Remarks
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Typography variant="body1">{remark}</Typography>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          Confirm & Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default BalanceConfirmationDialog;
